import _ from 'lodash';

import { departmentsArray } from './departments';

/**
 * @type {Object}
 */
export const PERMISSIONS = {
  ADMINISTRATOR: 'administrator',
  READ: 'read',
  CREATE: 'create',
  WRITE: 'write',
  DELETE: 'delete',
};

/**
 * @type {Array.<String>}
 */
export const permissionsArray = _.values(PERMISSIONS);

/**
 * @param {String} key
 * @return {String}
 */
export const toPermissionKey = key => _.toUpper(key);

/**
 * @type {Object}
 */
export const DEPARTMENTS_PERMISSIONS = (() => {
  const departmentsPermissions = {};

  _.forEach(departmentsArray, department => {
    const departmentKey = toPermissionKey(department);

    if (!_.isObject(departmentsPermissions[departmentKey])) {
      departmentsPermissions[departmentKey] = {};
    }

    _.forEach(permissionsArray, permission => {
      const permissionKey = toPermissionKey(permission);
      const notAdmin = permission !== PERMISSIONS.ADMINISTRATOR;

      if (notAdmin && _.isUndefined(departmentsPermissions[departmentKey][permissionKey])) {
        departmentsPermissions[departmentKey][permissionKey] = `${department}_${permission}`;
      }
    });
  });

  return {
    ...departmentsPermissions,
    [toPermissionKey(PERMISSIONS.ADMINISTRATOR)]: PERMISSIONS.ADMINISTRATOR,
  };
})();

/**
 * @param {Array.<String>} excludedRoles
 * @param {Array.<String>} userAccess
 * @return {Boolean}
 */
export const userHasPermission = (requiredPermissions, userAccess = []) =>
  _.some(requiredPermissions, requiredPermission => _.includes(userAccess, requiredPermission));
